module.exports = __webpack_public_path__ + "img/empty-img.066ece1c.png";